/**
 * ljv-search-precision.js
 *
 * Shopifys Storefront-Suche ist semantisch: sie sucht nicht nach dem Wort,
 * sondern nach der vermuteten Absicht, und liefert deshalb NIE null Treffer.
 * "Kleid" ergab 116 Treffer bei 5 Kleidern, "Bananenbrot" 8 Treffer.
 *
 * Abschalten laesst sich das nicht -- weder in Search & Discovery noch per
 * Parameter. Dokumentiert ist nur: sobald die Anfrage Shopify-Suchsyntax
 * nutzt (feld:wert, OR, AND, Anfuehrungszeichen), deaktiviert Shopify fuer
 * diese eine Anfrage die semantische Erweiterung.
 *
 * Deshalb schreiben wir Einwort-Suchen um:
 *   Kleid  ->  title:Kleid OR product_type:Kleid OR tag:Kleid
 *
 * Gemessen am 09.09.2026: Kleid 4 statt 116, Hose 43 statt 83,
 * T-Shirt 46 statt 127, Bananenbrot 0 statt 8.
 *
 * Zwei Grenzen, die den Rueckfall noetig machen:
 * - Mehrwortsuchen scheitern an deutschen Endungen ("schwarze" steht nirgends,
 *   die Produkte heissen "schwarz"). Die bleiben deshalb unveraendert.
 * - Die Suchsyntax deaktiviert auch die Tippfehlertoleranz. "Kleidd" ergibt
 *   streng gesucht null Treffer. Genau dafuer faellt die Seite bei null
 *   Treffern automatisch auf die normale Suche zurueck.
 */
(function () {
  'use strict';

  var FIELDS = ['title', 'product_type', 'tag'];
  var FALLBACK_FLAG = 'ljv_fallback';

  // Zeichen und Woerter, die bereits Shopify-Suchsyntax sind. Wer die selbst
  // eintippt, weiss was er tut -- solche Anfragen fassen wir nicht an.
  var HAS_SYNTAX = /["():]|\b(OR|AND|NOT)\b/;

  function isSingleWord(term) {
    term = (term || '').trim();
    if (!term) return false;
    if (/\s/.test(term)) return false;
    return !HAS_SYNTAX.test(term);
  }

  function toFieldQuery(term) {
    return FIELDS.map(function (field) {
      return field + ':' + term;
    }).join(' OR ');
  }

  function isFieldQuery(term) {
    return (term || '').indexOf('product_type:') !== -1;
  }

  /** Holt aus "title:Kleid OR product_type:Kleid OR tag:Kleid" wieder "Kleid". */
  function rawTermOf(fieldQuery) {
    var first = (fieldQuery || '').split(' OR ')[0] || '';
    var colon = first.indexOf(':');
    return colon === -1 ? first : first.slice(colon + 1);
  }

  // ---------------------------------------------------------------- Absenden

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;

      var method = (form.getAttribute('method') || 'get').toLowerCase();
      if (method !== 'get') return;

      var input = form.querySelector('input[name="q"]');
      if (!input || !isSingleWord(input.value)) return;

      // Der Rueckfall darf nicht sofort wieder umgeschrieben werden.
      if (new URLSearchParams(window.location.search).get(FALLBACK_FLAG)) return;

      input.value = toFieldQuery(input.value.trim());
    },
    true
  );

  // ------------------------------------------------------- Rueckfall bei null

  var state = window.ljvSearch;
  if (!state || state.count !== 0 || !isFieldQuery(state.terms)) return;

  var raw = rawTermOf(state.terms).trim();
  if (!raw) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get(FALLBACK_FLAG)) return; // schon zurueckgefallen, sonst Schleife

  params.set('q', raw);
  params.set(FALLBACK_FLAG, '1');
  window.location.replace(window.location.pathname + '?' + params.toString());
})();
